import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesExcluir.vue?vue&type=template&id=44d343dc"
import script from "./LicitacaoAtualizacaoAcoesExcluir.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports